import { fetchUtils } from 'react-admin';
import { stringify } from 'query-string';
import { IS_DEMO, demoResponse } from './demoData';
import { API_BASE_URL } from './config';
import { getToken } from './authStorage';

const apiUrl = API_BASE_URL;

export const httpClient = (url, options = {}) => {
    // Single choke point: every page reaches the API through here, so demo mode
    // only has to be intercepted once rather than at each call site.
    if (IS_DEMO) {
        return Promise.resolve({ status: 200, headers: new Headers(), json: demoResponse(url, options) });
    }
    if (!options.headers) {
        options.headers = new Headers({ Accept: 'application/json' });
    }
    const token = getToken();
    if (token) {
        options.headers.set('Authorization', `Bearer ${token}`);
    }
    return fetchUtils.fetchJson(url, options);
};

const convertFileToBase64 = file =>
    new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result);
        reader.onerror = reject;

        reader.readAsDataURL(file.rawFile);
    });

export default {
    getList: (resource, params) => {
        const url = `${apiUrl}/${resource}`;

        return httpClient(url).then(({ headers, json }) => ({
            data: json.docs.map(doc => ({ id: doc._id, ...doc })),
            total: 9999999,
        }));
    },

    getOne: (resource, params) =>
        httpClient(`${apiUrl}/${resource}/${params.id}`).then(({ json }) => ({
            data: { id: json._id, ...json },
        })),

    getMany: (resource, params) => {
        const url = `${apiUrl}/${resource}`;
        return httpClient(url).then(({ json }) => ({ data: json.docs }));
    },

    getManyReference: (resource, params) => {
        const url = `${apiUrl}/${resource}`;
        return httpClient(url).then(({ headers, json }) => ({
            data: json.docs,
            total: json.totalDocs,
        }));
    },

    update: (resource, params) => {
        if (resource == 'defaultservices' && params.data.tags && !Array.isArray(params.data.tags)) {
            params.data.tags = params.data.tags.split(",")
        }

        if (resource === 'defaultservices' && params.data.picture) {
            return convertFileToBase64(params.data.picture).then(base64Picture => {
                delete params.data.picture
                params.data.b64ImageData = base64Picture
                console.log(params.data)
                return httpClient(`${apiUrl}/${resource}/${params.id}`, {
                    method: 'PATCH',
                    body: JSON.stringify(params.data),
                }).then(({ json }) => ({ data: { ...json, id: json._id } }))
            })
        } else {
            return httpClient(`${apiUrl}/${resource}/${params.id}`, {
                method: 'PATCH',
                body: JSON.stringify(params.data),
            }).then(({ json }) => ({ data: { ...json, id: json._id } }))
        }

    },

    updateMany: (resource, params) => {
        const query = {
            filter: JSON.stringify({ id: params.ids }),
        };
        return httpClient(`${apiUrl}/${resource}?${stringify(query)}`, {
            method: 'PATCH',
            body: JSON.stringify(params.data),
        }).then(({ json }) => ({ data: json }));
    },

    create: (resource, params) => {
        if (resource == 'defaultservices' && params.data.tags && !Array.isArray(params.data.tags)) {
            params.data.tags = params.data.tags.split(",")
        }

        if (resource === 'defaultservices' && params.data.picture) {
            return convertFileToBase64(params.data.picture).then(base64Picture => {
                delete params.data.picture
                params.data.b64ImageData = base64Picture
                return httpClient(`${apiUrl}/${resource}`, {
                    method: 'POST',
                    body: JSON.stringify(params.data),
                }).then(({ json }) => ({ data: { ...json, id: json._id } }))
            })
        } else {
            return httpClient(`${apiUrl}/${resource}`, {
                method: 'POST',
                body: JSON.stringify(params.data),
            }).then(({ json }) => ({ data: { ...json, id: json._id } }))
        }

    },

    delete: (resource, params) =>
        httpClient(`${apiUrl}/${resource}/${params.id}`, {
            method: 'DELETE',
        }).then(({ json }) => ({ data: params.id })),

    deleteMany: (resource, params) => {
        params.ids.map(id => {
            httpClient(`${apiUrl}/${resource}/${id}`, {
                method: 'DELETE',
            }).then(({ json }) => ({ data: json }))
        })
        return new Promise((resolve, reject) => { resolve() }).then(() => ({ data: params.ids }))

    },
};
